mutation DuplicateDripSequence($input: DripSequenceDuplicateInput!) {
    dripSequenceDuplicate(input: $input) {
        dripSequence {
            id
            name
            htmlUrlPath
        }
    }
}
